import React, { useState, useEffect, useCallback } from 'react'
import ReactDOM from 'react-dom'
import styled from 'styled-components'
import { ResponsiveSVG } from 'ui/acro'

import closeSVG from '../../../../../assets/images/X.svg'

const DrawerBackdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 10040;
  background: rgba(0, 0, 0, 0.5);
`

const DrawerPanel = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10041;
  max-height: 80vh;
  background: #fff;
  border-radius: 8px 8px 0 0;
  overflow: auto;
  padding-bottom: env(safe-area-inset-bottom, 16px);
`

const DrawerHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 38px 16px 16px;
`

const DrawerTitle = styled.p`
  margin: 0;
  font-family: 'Proxima-nova', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.352px;
  color: #000;
  padding-right: 16px;
`

const CloseBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  flex-shrink: 0;
  line-height: 0;
`

const MobileStickyModal = ({ open, onClose, title, children }) => {
  if (!open) return null

  const node = (
    <>
      <DrawerBackdrop role='presentation' onClick={onClose} />
      <DrawerPanel role='dialog' aria-modal='true'>
        <DrawerHeader>
          <DrawerTitle>{title}</DrawerTitle>
          <CloseBtn type='button' onClick={onClose} aria-label='Close'>
            <ResponsiveSVG SVG={closeSVG} width='20px' height='20px' />
          </CloseBtn>
        </DrawerHeader>
        {children}
      </DrawerPanel>
    </>
  )

  return ReactDOM.createPortal(node, document.body)
}

export default MobileStickyModal
